import { IAssistantMessage, IMessage } from '@bimser/components/dist/BCChat/entities/IMessage';

export enum EAiAssistantPanelLocation {
	Web = 1,
	Ide = 2
}

export interface IAiAssistantPayload {
	panelLocation: EAiAssistantPanelLocation;
	refresh?: boolean;
	projectSecretKey?: string;
	projectPassKey?: string;
}

export interface IUseAiAssistantProps {
	payload: IAiAssistantPayload;
	sessionId: string;
	pushMessage: (message: IAssistantMessage | IMessage) => void;
	updateMessage: (message: IAssistantMessage) => void;
	updateSessionId: (sessionId: string) => void;
	clearMessages: () => void;
}
